import { PurchasingRepository } from '@Purchasing/Data/Repository/PurchasingRepository'
import {
    PurchaseProcess,
    SupplierQuote,
    SupplierQuoteStatus,
} from '@Purchasing/Domain/Model/PurchaseProcess'
import {
    CreateSupplierQuotePayload,
    UpdateSupplierQuotePayload,
} from '@Purchasing/Data/DataSource/API/Entity/PurchaseProcess'

export interface GetSupplierQuotes {
    execute(processId: string): Promise<SupplierQuote[]>
}

export class GetSupplierQuotesUseCase implements GetSupplierQuotes {
    constructor(private repository: PurchasingRepository) {}
    execute(processId: string): Promise<SupplierQuote[]> {
        return this.repository.getQuotes(processId)
    }
}

export interface CreateSupplierQuote {
    execute(
        processId: string,
        payload: CreateSupplierQuotePayload
    ): Promise<SupplierQuote>
}

export class CreateSupplierQuoteUseCase implements CreateSupplierQuote {
    constructor(private repository: PurchasingRepository) {}
    execute(
        processId: string,
        payload: CreateSupplierQuotePayload
    ): Promise<SupplierQuote> {
        return this.repository.createQuote(processId, payload)
    }
}

export interface UpdateSupplierQuote {
    execute(
        processId: string,
        quoteId: string,
        payload: UpdateSupplierQuotePayload
    ): Promise<SupplierQuote>
}

export class UpdateSupplierQuoteUseCase implements UpdateSupplierQuote {
    constructor(private repository: PurchasingRepository) {}
    execute(
        processId: string,
        quoteId: string,
        payload: UpdateSupplierQuotePayload
    ): Promise<SupplierQuote> {
        return this.repository.updateQuote(processId, quoteId, payload)
    }
}

export interface UpdateSupplierQuoteStatus {
    execute(
        processId: string,
        quoteId: string,
        status: SupplierQuoteStatus
    ): Promise<SupplierQuote>
}

export class UpdateSupplierQuoteStatusUseCase
    implements UpdateSupplierQuoteStatus
{
    constructor(private repository: PurchasingRepository) {}
    execute(
        processId: string,
        quoteId: string,
        status: SupplierQuoteStatus
    ): Promise<SupplierQuote> {
        return this.repository.updateQuoteStatus(processId, quoteId, status)
    }
}

export interface SelectSupplierQuote {
    execute(processId: string, quoteId: string): Promise<PurchaseProcess>
}

export class SelectSupplierQuoteUseCase implements SelectSupplierQuote {
    constructor(private repository: PurchasingRepository) {}
    execute(processId: string, quoteId: string): Promise<PurchaseProcess> {
        return this.repository.selectQuote(processId, quoteId)
    }
}

export interface DeleteSupplierQuote {
    execute(processId: string, quoteId: string): Promise<void>
}

export class DeleteSupplierQuoteUseCase implements DeleteSupplierQuote {
    constructor(private repository: PurchasingRepository) {}
    execute(processId: string, quoteId: string): Promise<void> {
        return this.repository.deleteQuote(processId, quoteId)
    }
}
